import { formatAmount } from '../utils/format.js';
import PropTypes from 'prop-types';

const COLORS = [
  '#c9a440', '#ff6b6b', '#50fa7b', '#8be9fd', '#bd93f9',
  '#ffb86c', '#ff79c6', '#6272a4', '#f1fa8c', '#44475a'
];

export default function TaxBreakdown({ breakdown = [], gross = 0, currency = 'USD', displayCurrency, convert }) {
  if (!breakdown || breakdown.length === 0) return null;

  const _total = breakdown.reduce((sum, item) => sum + item.amount, 0);

  const convertAmount = (amount) => {
    if (displayCurrency && displayCurrency !== currency && convert) {
      return convert(amount, currency, displayCurrency);
    }
    return amount;
  };

  const displayCurr = displayCurrency || currency;

  return (
    <div className="tax-breakdown">
      <h3 className="tax-breakdown__title">Tax Breakdown</h3>
      <div className="tax-breakdown__items">
        {breakdown.map((item, i) => {
          const pct = gross > 0 ? (item.amount / gross) * 100 : 0;
          const color = COLORS[i % COLORS.length];
          const converted = convertAmount(item.amount);

          return (
            <div key={i} className="tax-breakdown__item">
              <div className="tax-breakdown__item-header">
                <span className="tax-breakdown__item-dot" style={{ background: color }} />
                <span className="tax-breakdown__item-label">{item.label}</span>
                <span className="tax-breakdown__item-amount">{formatAmount(converted, displayCurr)}</span>
              </div>
              <div className="tax-breakdown__bar-track">
                <div
                  className="tax-breakdown__bar-fill"
                  style={{
                    width: `${Math.min(pct, 100)}%`,
                    background: color,
                    transition: 'width 0.8s cubic-bezier(0.34, 1.56, 0.64, 1)'
                  }}
                />
              </div>
              <span className="tax-breakdown__pct">{pct.toFixed(1)}% of gross</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

TaxBreakdown.propTypes = {
  breakdown: PropTypes.arrayOf(PropTypes.shape({
    label:  PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
  })),
  gross:           PropTypes.number,
  currency:        PropTypes.string,
  displayCurrency: PropTypes.string,
  convert:         PropTypes.func,
}

TaxBreakdown.defaultProps = {
  breakdown:       [],
  gross:           0,
  currency:        'USD',
  displayCurrency: undefined,
  convert:         undefined,
}